const SECTIONS = [
    "Quick Actions",
    "Add funds",
    "Send funds",
    "Transfer funds"
]

export default SECTIONS